import { setTheme } from "theme/default/setTheme";

export const setColor_f5f5f5 = setTheme(({ theme }) => `color: ${theme.colors.color_f5f5f5}`);
